export interface Bonus {
  number: string
  title: string
  description: string
  tags: string[]
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Senior Balance & Stability Vault™',
    description:
      'Add even more variety to your balance programming with additional drills, stability progressions and practical session ideas you can integrate into your existing classes.',
    tags: ['Balance Drills', 'Stability Activities', 'Progressions', 'Session Ideas'],
  },
  {
    number: '02',
    title: 'Chair Fitness Collection™',
    description:
      'Need additional options for participants who benefit from seated or supported exercise? Use ready-to-use chair fitness resources to expand the ways you can adapt your programming.',
    tags: ['Seated Strength', 'Mobility', 'Coordination', 'Supported Movement', 'Chair Sessions'],
  },
  {
    number: '03',
    title: 'Express Class Builder™',
    description:
      'Short on planning time? Use quick class-building frameworks to organize structured senior fitness sessions without spending hours putting everything together.',
    tags: ['Choose the Goal', 'Choose the Activities', 'Build the Session', 'Coach'],
  },
  {
    number: '04',
    title: 'Mobility & Flexibility Library™',
    description:
      'Expand your mobility resources with additional movement preparation, flexibility and mobility sequences — perfect for adding variety to every part of your sessions.',
    tags: ['Warm-Ups', 'Cool-Downs', 'Mobility Blocks', 'Recovery Sessions'],
  },
  {
    number: '05',
    title: 'Senior Coach Printable Pack™',
    description:
      'Keep the professional side of your coaching organized with practical resources for everyday use.',
    tags: ['Class Planners', 'Trackers', 'Checklists', 'Session Sheets', 'Coaching Resources'],
  },
]
